import { Theme } from '@mui/material';
import styled from '@emotion/styled';
import { DataContext } from 'providers/data';
import { useContext, useEffect, useState } from 'react';

import { ParseIcInsurers } from 'utils/parseIcInsurers';
import { ParamsDataServicesPlatform } from 'utils/typeServices';

import { Box, Typography } from '@mui/material';
import NavTitle from 'components/views/NavTitle';
import HeaderSubPages from 'components/views/MyVehicles/HeaderSubPages';

import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';

type ParamsStyle = {
    theme?: Theme;
}

export const BoxCustom = styled(Box)(
    ({ theme }: ParamsStyle) => `
    display: flex;
    gap: 1.1875rem;
    flex-direction: column;

    a, p {
        display: flex;
        font-weight: 700;
        border-radius: 5px;
        aling-items: center;
        font-size: 1.5625rem;
        color: ${theme?.palette.primary.main};
        border: 2px solid #8D9BB5;
        justify-content: space-between;
        padding: .875rem 1rem .62rem;

        svg {
            width: 25px;
            height: auto;
        }
    }

    p {
        font-size: 1rem;
        font-weight: 600;
    }

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        p {
            font-size: 1.5625rem;
            font-weight: 700;
        }

        a, p {
            padding: .75rem 1.125rem .55rem;
        }
    }
`);

const InsuranceContact = () => {
    const [dataServicesPlatform, setDataServicesPlatform] = useState<ParamsDataServicesPlatform>();
    const { selectedCar, dataUsefulContacts, handleGetUsefulContacts } = useContext(DataContext);

    const handleShowValidate = (AssuntoContatoEnum: number) => {
        if (([2803, 2804, 2805, 2806].indexOf(selectedCar?.CD_PRODUTO || 0) >= 0) && (AssuntoContatoEnum === 5)) {
            const isAssistanceAdd = dataUsefulContacts?.ServicosAdicionaisContatos.find(({ CdProduto }) => [2984, 2974, 2985, 2975].indexOf(CdProduto) >= 0);

            if (isAssistanceAdd) {
                return true;
            }

            return false;
        }

        return true;
    }

    useEffect(() => {
        if (!dataUsefulContacts) {
            handleGetUsefulContacts({ token: localStorage.getItem('token')! });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (selectedCar && dataUsefulContacts) {
            const dataServicesPlatformSelected = dataUsefulContacts?.ServicosPlataforma?.find(({ NR_PLATAFORMA }) => selectedCar?.NR_PLATAFORMA === NR_PLATAFORMA);
            dataServicesPlatformSelected && setDataServicesPlatform(dataServicesPlatformSelected);
        }

    }, [selectedCar, dataUsefulContacts]);

    return (
        <HeaderSubPages>
            <Box sx={{ paddingBottom: '2rem', '#title-nav': { fontSize: '1rem' } }}>
                <NavTitle title='Prestador de serviço parceiro' />
                {dataServicesPlatform?.CODIGO_SEGURADORA ?
                    <Box sx={{
                        padding: '2.43rem 0 1rem',
                        'svg': {
                            width: 'auto',
                            height: 'auto',
                            maxHeight: '6.875rem'
                        }
                    }}>
                        {ParseIcInsurers(dataServicesPlatform?.CODIGO_SEGURADORA)}
                    </Box>
                    :
                    <div />
                }
                <Box sx={{
                    display: 'grid',
                    width: '100%',
                    gridTemplateColumns: {
                        xs: '1fr',
                        md: '1fr 1fr'
                    },
                    columnGap: '2rem',
                    rowGap: {
                        xs: '.4rem',
                        md: '1.3rem'
                    }
                }}>
                    {dataServicesPlatform?.ContatosAssistencia?.map(({ Assunto, LigacoesLocais, TodasRegioes, DemaisRegioes, AssuntoContatoEnum }, index) => (
                        (LigacoesLocais || TodasRegioes || DemaisRegioes) && handleShowValidate(AssuntoContatoEnum) &&
                        <Box key={index}>
                            <Typography
                                variant='subtitle2'
                                color='primary.light'
                                fontWeight={700}
                                sx={{
                                    padding: {
                                        xs: '1.375rem 0 1.5rem',
                                        md: '1.375rem 0 1.3125rem'
                                    }
                                }}>
                                {[8, 4].indexOf(AssuntoContatoEnum) >= 0 ?
                                    'Ituran Serviços LTDA'
                                    :
                                    Assunto
                                }
                            </Typography>
                            <BoxCustom>
                                {LigacoesLocais &&
                                    <Box>
                                        <Typography variant='subtitle2' paddingBottom='.375rem'>
                                            Regiões Metropolitanas
                                        </Typography>
                                        <a href={`tel:${LigacoesLocais}`}>
                                            {LigacoesLocais}
                                            <LocalPhoneOutlinedIcon />
                                        </a>
                                    </Box>
                                }
                                {TodasRegioes &&
                                    <Box>
                                        <Typography variant='subtitle2' paddingBottom='.375rem'>
                                            Todas Regiões
                                        </Typography>
                                        <a href={`tel:${TodasRegioes}`}>
                                            {TodasRegioes}
                                            <LocalPhoneOutlinedIcon />
                                        </a>
                                    </Box>
                                }
                                {DemaisRegioes &&
                                    <Box>
                                        <Typography variant='subtitle2' paddingBottom='.375rem'>
                                            Demais Regiões
                                        </Typography>
                                        <a href={`tel:${DemaisRegioes}`}>
                                            {DemaisRegioes}
                                            <LocalPhoneOutlinedIcon />
                                        </a>
                                    </Box>
                                }
                            </BoxCustom>
                        </Box>
                    ))}
                </Box>
            </Box>
        </HeaderSubPages>
    );
}

export default InsuranceContact;